import { isEmpty } from 'lodash';
import { replace } from 'redux-first-router';

import { querySel } from '@location';
import { emptyObj } from '@modules/shared/constants';
import {
  ROUTE_CHANGE_UNIT_REPORTS,
  ROUTE_REPORTS,
  setOrganization,
} from '@modules/shared/duck/actions';
import { organizationPositionsSel } from '@modules/shared/duck/selectors';
import { newPermissions } from '@shared/newPermissions';

import { ReportsPage, ReportsPagePlaceholder } from './components';

const routes = {
  [ROUTE_REPORTS]: {
    path: '/reports',
    Component: ReportsPage,
    Placeholder: ReportsPagePlaceholder,
    titleId: 'page.reports',
    permission: newPermissions.VIEW_REPORTS_PAGE,
  },
  [ROUTE_CHANGE_UNIT_REPORTS]: {
    path: '/reportsOrgChange',
    Component: ReportsPagePlaceholder,
    permission: newPermissions.VIEW_REPORTS_PAGE,
    Placeholder: ReportsPagePlaceholder,
    titleId: 'page.reports',
    thunk: (dispatch, getState) => {
      // SBL-6769 : Route added due to hyperlinks coming from Scoutbook
      // /reports? route has an unidentifiable 403 error
      // HyperLink : /reportsOrgChange?organizationGuid=:orgGuid
      const state = getState();
      const positions = organizationPositionsSel(state);
      const { organizationGuid = '', OrganizationGUID } =
        querySel(state) || emptyObj;
      const redirectOrgGuid = organizationGuid || OrganizationGUID;

      if (!isEmpty(redirectOrgGuid) && !isEmpty(positions)) {
        const foundPosition = positions.find(
          p => p.organizationGuid === redirectOrgGuid,
        );

        if (foundPosition) {
          dispatch(
            setOrganization({
              guid: foundPosition.organizationGuid,
              programType: foundPosition.programType,
              parentOrgGuid: foundPosition.organizationGuid,
            }),
          );
          replace('/reports');
        }
      }
    },
  },
};

export default routes;
